import { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';

class UrlProcessable extends Component {
	componentDidMountAddOn = () => {
		const { processUrl } = this.props;
		processUrl(true);
	}

	UNSAFE_componentWillReceivePropsAddOn = ({ params, location, processUrl }) => {
		const lastProps = this.props;
		const reloadCounters = !isEqual(location.search, lastProps.location.search);

		/**
		 * processUrl when the search param
		 * has changed, or the viewType has
		 * also changed
		 */
		if (
			!isEqual(params.viewType, lastProps.params.viewType)
			|| !isEqual(location.search, lastProps.location.search)
		) processUrl(reloadCounters);
	}
}

UrlProcessable.propTypes = {
	processUrl : PropTypes.func.isRequired,
	location   : PropTypes.object.isRequired,
	params     : PropTypes.object.isRequired,
};

export default UrlProcessable;
